import { useMemo } from 'react';
import { Text } from '@mercator-gcp/grout';
import type { ProjectSize } from 'types';

type TProps = {
  minTotalFloors?: ProjectSize['total_floors_min'];
  maxTotalFloors?: ProjectSize['total_floors_max'];
};

const NumberOfFloors = ({ minTotalFloors, maxTotalFloors }: TProps) => {
  const label = useMemo(() => {
    if (minTotalFloors === maxTotalFloors) {
      if (maxTotalFloors === 1) {
        return `${maxTotalFloors} floor`;
      }

      return `${maxTotalFloors} floors`;
    }

    return `${minTotalFloors} - ${maxTotalFloors} floors`;
  }, [minTotalFloors, maxTotalFloors]);

  return <Text>{label}</Text>;
};

export default NumberOfFloors;
